/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.piesync.bridge.rpc.ConnectionsRpc
 */

import type {
  ChirpAvroRpcDetails,
  Requestify,
  unhandledEnumCase,
  Default,
  HubspotMetadata,
} from 'rpc-client-utils';

export type StandardErrorCategory =
  | 'OBJECT_NOT_FOUND'
  | 'VALIDATION_ERROR'
  | 'OBJECT_ALREADY_EXISTS'
  | 'API_LIMIT'
  | 'INVALID_AUTHENTICATION'
  | 'INTERNAL_ERROR'
  | 'RATE_LIMITS'
  | 'EXPIRED_AUTHENTICATION'
  | 'MISSING_SCOPES'
  | 'SERVICE_UNAVAILABLE'
  | 'BANNED'
  | 'GATED'
  | 'MISSING_PERMISSIONS'
  | unhandledEnumCase;

/**
 * Record for com.hubspot.chirp.core.CausalChainLink
 */
export type CausalChainLink = {
  coordinates: ChirpMethodCoordinates;
  errorClass: string;
  errorMessage?: string;
};

/**
 * Record for com.hubspot.chirp.core.ChirpMethodCoordinates
 */
export type ChirpMethodCoordinates = { service: string; method: string };

export type EmptyError = {
  chirpErrorMessage?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry?: boolean;
};

export type AppAccountsResponseAccount = {
  accountId: number;
  accountName: string;
  accountIdentifier: string;
  accountInstance?: string;
  userId: number;
};

export type AppAccountsResponseV2 = {
  appId: number;
  appName: string;
  appLevel: AppLevel;
  accounts: Default<AppAccountsResponseAccount[]>;
};

export type AppLevel = 'PORTAL' | 'USER' | unhandledEnumCase;

export type ActivateConnectionsRequest = { connectionIds: Default<number[]> };

export type ActivateConnectionsResponse = {
  connectionIds: Default<number[]>;
  errors: Default<BatchResponseError[]>;
};

export type BatchResponseError = {
  category: StandardErrorCategory;
  message: string;
  context: Default<Record<string, string[]>>;
};

export type ConfiguredConnection = {
  portalId: number;
  rules: Rules;
  conflictResolution: ConflictResolution;
  matchingFilter?: MatchingFilter;
  stages?: StageArrangement;
  partitionMapping?: PartitionMapping;
  matchingConfiguration?: MatchingConfiguration;
  eventSyncPreference: Default<boolean>;
  /** @deprecated */
  eventIngestionEnabled: Default<boolean>;
  id: number;
  status: ConnectionStatus;
  /** @deprecated */
  scope: ConnectionScopeSummary;
  datasetConfiguration?: ConnectionDatasetConfiguration;
};

export type ConflictResolution =
  | 'NO_RESOLUTION'
  | 'DEFAULT_TO_HUBSPOT'
  | 'DEFAULT_TO_REMOTE'
  | unhandledEnumCase;

export type ConnectionResponse = { connection?: ConfiguredConnection };

export type ConnectionSettingsMappingsUpdate = {
  connectionSettings: ConnectionSettingsUpdate;
  fieldMappings: UpdateFieldMappingsRequest;
  matchingConfiguration?: MatchingConfiguration;
};

export type ConnectionSettingsUpdate = {
  conflictResolution: ConflictResolution;
  matchingFilter?: MatchingFilterUpdate;
  rules: Rules;
  stages?: ConfiguredStageMappings;
  partitionMapping?: PartitionMapping;
  defaultValueDatasetParameters: Default<DatasetParameter[]>;
  generalDatasetParameters: Default<DatasetParameter[]>;
  recordIdDatasetParameters: Default<DatasetParameter[]>;
  lastModifiedDatasetParameters: Default<DatasetParameter[]>;
  subscriptionSettingDatasetParameters: Default<DatasetParameter[]>;
};

export type ConnectionStatus =
  | 'CREATED'
  | 'STARTED'
  | 'PAUSED'
  | 'REMOVED'
  | 'INVALID'
  | unhandledEnumCase;

export type CreateConnectionsResponse = {
  connections: Default<SummarizedConnection[]>;
  errors: Default<BatchResponseError[]>;
};

export type Direction = 'BOTH' | 'INBOUND' | 'OUTBOUND' | unhandledEnumCase;

export type DisableConnectionsRequest = { connectionIds: Default<number[]> };

export type DisableConnectionsResponse = {
  connectionIds: Default<number[]>;
  errors: Default<BatchResponseError[]>;
};

export type EnableConnectionsRequest = { connectionIds: Default<number[]> };

export type EnableConnectionsResponse = {
  connectionIds: Default<number[]>;
  errors: Default<BatchResponseError[]>;
};

export type MatchingFilter = {
  name: MatchingSwitchName;
  value: boolean;
  editable: boolean;
};

export type MatchingFilterUpdate = { name: MatchingSwitchName; value: boolean };

export type MatchingSwitchName =
  | 'email_only'
  | 'companies_email_name_only'
  | 'sku_only'
  | 'products_name_only'
  | unhandledEnumCase;

export type PollStatus =
  | 'NO_REFRESHABLE_DATA'
  | 'NEVER_REFRESHED'
  | 'ONGOING'
  | 'SUCCESS'
  | 'FAILURE'
  | 'PARTIAL_FAILURE'
  | unhandledEnumCase;

export type RefreshUpstreamDirective =
  | 'HUBSPOT'
  | 'REMOTE'
  | 'BOTH'
  | unhandledEnumCase;

export type SummarizedConnection = {
  direction?: Direction;
  eventSyncPreference: Default<boolean>;
  id: number;
  status: ConnectionStatus;
  /** @deprecated */
  scope: ConnectionScopeSummary;
  datasetConfiguration?: ConnectionDatasetConfiguration;
};

export type TriggerBatchResponse = {
  successful: Default<number[]>;
  unsuccessful: Default<number[]>;
};

export type UpdateOnlyDirection =
  | 'NONE'
  | 'BOTH'
  | 'INBOUND'
  | 'OUTBOUND'
  | unhandledEnumCase;

export type UpstreamRefresh = { status: PollStatus; refreshedAt: number };

export type UpstreamRefreshResponse = { refresh: UpstreamRefresh };

export type ConnectionEvent =
  | 'CREATED'
  | 'CONFIGURATION_UPDATED'
  | 'ACTIVATED'
  | 'ENABLED'
  | 'DISABLED'
  | 'DELETED'
  | 'RESET'
  | 'MAPPING_UPDATED'
  | 'TRIGGERED'
  | 'PURGED'
  | 'VALIDATED'
  | 'INVALIDATED'
  | unhandledEnumCase;

export type ConnectionLifecycleEventResponse = {
  id: number;
  portalId: number;
  connectionId: number;
  user: User;
  event: ConnectionEvent;
  createdAt: number;
  accountId?: number;
  platformConfigurationVersion?: number;
  initialSyncCompleteTime?: number;
  objectTypeId?: string;
};

export type User = {
  id: number;
  firstName?: string;
  lastName?: string;
  email?: string;
};

export type ConfiguredField = {
  fieldId?: string;
  newFieldName?: string;
  compatibleTypeId: string;
};

export type ConfiguredFieldMapping = {
  type: MappingType;
  restriction: MappingRestriction;
  status: MappingStatus;
  fields: ConfiguredFields;
};

export type ConfiguredFields = {
  hubSpot: ConfiguredField;
  remote: ConfiguredField;
};

export type FieldIdentifier = {
  fieldId: string;
  upstreamFieldId?: string;
  label: string;
};

export type MappingRestriction =
  | 'NONE'
  | 'INBOUND'
  | 'OUTBOUND'
  | unhandledEnumCase;

export type MappingStatus = 'ENABLED' | 'DISABLED' | unhandledEnumCase;

export type MappingType =
  | 'DEFAULT'
  | 'CUSTOM'
  | 'ASSOCIATION'
  | 'CUSTOM_ASSOCIATION'
  | unhandledEnumCase;

export type UpdateFieldMappingsRequest = {
  mappings: Default<ConfiguredFieldMapping[]>;
};

export type DefaultMatchingIdentifier =
  | 'EMAIL'
  | 'COMPANY_NAME_OR_DOMAIN_NAME'
  | 'SKU'
  | 'DISCOUNT_CODE'
  | 'PHONE_NUMBER'
  | unhandledEnumCase;

export type MatchingConfiguration = {
  matchingType: MatchingType;
  matchingIdentifiers?: MatchingIdentifiers;
  supportsDefaultMatchingOn?: DefaultMatchingIdentifier;
};

export type MatchingIdentifiers = {
  hubSpot: FieldIdentifier;
  remote: FieldIdentifier;
};

export type MatchingType =
  | 'DEFAULT'
  | 'DISABLED'
  | 'CUSTOM'
  | unhandledEnumCase;

export type PartitionMapping = {
  defaultInboundPartition?: string;
  outboundPartitions: Default<string[]>;
  inboundType?: string;
};

export type Filter = {
  keys: Default<string[]>;
  params: Default<SelectedParam[]>;
  templateId: string;
  error?: RuleError;
};

export type Filters = {
  inboundFilters: Default<Filter[][]>;
  outbound?: OutboundFilter;
  templates?: Templates;
};

export type OutboundFilter = { listId?: number };

export type RuleError =
  | 'TEMPLATE_REMOVED'
  | 'INVALID_PARAMS'
  | 'UNKNOWN'
  | 'REMOTE_REFRESH_FAILED'
  | unhandledEnumCase;

export type Rules = {
  direction: Direction;
  possibleDirections: Default<Direction[]>;
  updateOnlyDirection: UpdateOnlyDirection;
  filters: Filters;
};

export type SelectedParam = {
  name: string;
  values: Default<SelectedParamValue[]>;
  type?: string;
};

export type SelectedParamValue = { label: string; value: string };

export type Templates = { predicates: Default<PredicateTrieNode[]> };

export type Param = {
  label: string;
  name: string;
  type: string;
  options: Default<ParamOption[]>;
  multiValue: boolean;
};

export type ParamOption = { label: string; value: string };

export type PredicateCategory = 'POPULAR' | 'ALL' | unhandledEnumCase;

export const PredicateTrieCategoryInternalNodeTypename =
  'com.hubspot.piesync.bridge.core.models.connection.rule.predicate.PredicateTrieCategoryInternalNode';
export const PredicateTrieCategoryInternalNodeDiscriminant = 'category';
export const PredicateTrieCategoryInternalNodeDiscriminantKey = 'type';
export type PredicateTrieCategoryInternalNode = {
  nextKeys: Default<PredicateTrieNode[]>;
  key: string;
  category: PredicateCategory;
  __typename: 'com.hubspot.piesync.bridge.core.models.connection.rule.predicate.PredicateTrieCategoryInternalNode';
} & { type?: 'category' };

export const PredicateTrieCategoryLeafNodeTypename =
  'com.hubspot.piesync.bridge.core.models.connection.rule.predicate.PredicateTrieCategoryLeafNode';
export const PredicateTrieCategoryLeafNodeDiscriminant = 'categoryLeaf';
export const PredicateTrieCategoryLeafNodeDiscriminantKey = 'type';
export type PredicateTrieCategoryLeafNode = {
  templateId: string;
  params: Default<Param[]>;
  category: PredicateCategory;
  key: string;
  __typename: 'com.hubspot.piesync.bridge.core.models.connection.rule.predicate.PredicateTrieCategoryLeafNode';
} & { type?: 'categoryLeaf' };

export const PredicateTrieLeafNodeTypename =
  'com.hubspot.piesync.bridge.core.models.connection.rule.predicate.PredicateTrieLeafNode';
export const PredicateTrieLeafNodeDiscriminant = 'leaf';
export const PredicateTrieLeafNodeDiscriminantKey = 'type';
export type PredicateTrieLeafNode = {
  templateId: string;
  params: Default<Param[]>;
  key: string;
  __typename: 'com.hubspot.piesync.bridge.core.models.connection.rule.predicate.PredicateTrieLeafNode';
} & { type?: 'leaf' };

export const PredicateTrieNodeDiscriminantKey = 'type';
export type PredicateTrieNode =
  | PredicateTrieLeafNode
  | PredicateTrieCategoryLeafNode
  | PredicateTrieCategoryInternalNode;

export type ConfiguredConnectionScope = {
  scopeName: string;
  scopeLabel: string;
  value: string;
  valueLabel: string;
  type: ComHubspotPiesyncBridgeCoreModelsConnectionScope.DatasetType;
};

export type ConfiguredHubSpotObjectType = {
  objectTypeId: string;
  labels: ObjectTypeLabels;
};

export type ConfiguredObjectTypes = {
  hubSpot: ConfiguredHubSpotObjectType;
  remote: ConfiguredRemoteObjectType;
};

export type ConfiguredRemoteObjectType = {
  value: string;
  labels: ObjectTypeLabels;
  objectTypeIdentifier: Default<ObjectTypeIdentifier>;
};

export type ConnectionScopeState = 'SETUP' | 'FINAL' | unhandledEnumCase;

/**
 *  @deprecated use ConnectionDatasetConfiguration instead
 */
export type ConnectionScopeSummary = {
  /** @deprecated */
  state: Default<ConnectionScopeState>;
  objectTypes?: ConfiguredObjectTypes;
  scopes: Default<ConfiguredConnectionScope[]>;
};

export type ObjectTypeLabels = { singular: string; plural: string };

export type ScopesRequest = {
  objectTypes: SelectedObjectTypes;
  scopes: Default<SelectedScope[]>;
  direction?: Direction;
};

export type SelectedObjectTypes = {
  hubSpotObjectTypeId: string;
  remote: string;
};

export type SelectedScope = {
  name: string;
  label: Default<string>;
  value: string;
};

export namespace ComHubspotPiesyncBridgeCoreModelsConnectionScope {
  export type DatasetType =
    | 'GENERAL'
    | 'SCOPE'
    | 'LAST_MODIFIED'
    | 'RECORD_ID'
    | 'DEFAULT_VALUE'
    | 'SUBSCRIPTION_SETTING'
    | unhandledEnumCase;
}

export type ConfiguredMappedStage = {
  stageId: string;
  stageLabel: string;
  pipelineId?: string;
  pipelineLabel?: string;
};

export type ConfiguredMappedStages = {
  remote: ConfiguredMappedStage;
  hubSpot: ConfiguredMappedStage;
};

export type ConfiguredStageMappings = {
  mappings: Default<ConfiguredMappedStages[]>;
};

export type MappedStage = {
  stageId?: string;
  stageLabel?: string;
  pipelineId?: string;
};

export type Options = { remote: Default<Stage[]>; hubSpot: Default<Stage[]> };

export type Stage = {
  stageId: string;
  stageLabel: string;
  pipelineId?: string;
  pipelineLabel?: string;
};

export type StageArrangement = {
  mappings: Default<StagePair[]>;
  options: Options;
  remoteStageLabel?: string;
  remoteStagesAllowable: Default<boolean>;
};

export type StageMappingError =
  | 'REMOTE_UNAVAILABLE'
  | 'HUBSPOT_UNAVAILABLE'
  | 'BOTH_UNAVAILABLE'
  | unhandledEnumCase;

export type StagePair = {
  remote: MappedStage;
  hubSpot: MappedStage;
  error?: StageMappingError;
};

export type ConfiguredDatasetParameter = {
  name: string;
  label: string;
  value: string;
  valueLabel: string;
  type: ComHubspotPiesyncBridgeCoreModelsDatasetparameter.DatasetType;
};

export type ConnectionDatasetConfiguration = {
  /** @deprecated */
  state: Default<ConnectionDatasetState>;
  objectTypes?: ConfiguredObjectTypes;
  scopeDatasetParameters: Default<ConfiguredDatasetParameter[]>;
  generalDatasetParameters: Default<ConfiguredDatasetParameter[]>;
  recordIdDatasetParameters: Default<ConfiguredDatasetParameter[]>;
  lastModifiedDatasetParameters: Default<ConfiguredDatasetParameter[]>;
  subscriptionSettingDatasetParameters: Default<ConfiguredDatasetParameter[]>;
  defaultValueDatasetParameters: Default<ConfiguredDatasetParameter[]>;
};

export type ConnectionDatasetState = 'SETUP' | 'FINAL' | unhandledEnumCase;

export type DatasetParameter = {
  name: string;
  value: string;
  label: Default<string>;
};

export namespace ComHubspotPiesyncBridgeCoreModelsDatasetparameter {
  export type DatasetType =
    | 'GENERAL'
    | 'SCOPE'
    | 'LAST_MODIFIED'
    | 'RECORD_ID'
    | 'DEFAULT_VALUE'
    | 'SUBSCRIPTION_SETTING'
    | unhandledEnumCase;
}

export type ObjectTypeIdentifier = {
  name: string;
  scopes: Default<ConfiguredDatasetParameter[]>;
};

export type ConnectionSummary = {
  connectionId: number;
  accountId: number;
  objectTypes: ConfiguredObjectTypes;
  direction: Direction;
  status: ConnectionStatus;
  datasetConfiguration: ConnectionDatasetConfiguration;
};

export type PortalOverviewResponse = {
  apps: Default<AppAccountsResponseV2[]>;
  connections: Default<ConnectionSummary[]>;
};

export type ActivateConnectionError = {
  reason: ComHubspotPiesyncBridgeModelsConnectionAbstractActivateConnectionError.FailureReason;
  chirpErrorMessage?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
};

export type ActivateConnectionRequest = { connectionId: number };

export type ActivateConnectionResponse = {};

export type CreateConnectionError = {
  reason: ComHubspotPiesyncBridgeModelsConnectionAbstractCreateConnectionError.FailureReason;
  missingScopes: Default<string[]>;
  remoteErrors: Default<string[]>;
  hubspotErrors: Default<string[]>;
  chirpErrorMessage?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
};

export type CreateConnectionRequest = {
  accountId: number;
  scopesRequest: ScopesRequest;
};

export type CreateConnectionResponse = { connection: SummarizedConnection };

export type CreateConnectionsError = {
  reason: ComHubspotPiesyncBridgeModelsConnectionAbstractCreateConnectionsError.FailureReason;
  missingScopes: Default<string[]>;
  chirpErrorMessage?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
};

export type CreateConnectionsRequest = {
  accountId: number;
  requests: Default<ScopesRequest[]>;
};

export type DeleteConnectionError = {
  chirpErrorMessage?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
};

export type DeleteConnectionRequest = { connectionId: number };

export type DeleteConnectionResponse = {};

export type DisableConnectionError = {
  chirpErrorMessage?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
};

export type DisableConnectionRequest = { connectionId: number };

export type DisableConnectionResponse = {};

export type EnableConnectionError = {
  chirpErrorMessage?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
};

export type EnableConnectionRequest = { connectionId: number };

export type EnableConnectionResponse = {};

export type FieldRankingScore = { type: FieldRankingScoreType; score: number };

export type FieldRankingScoreType = 'FILL_RATE' | 'USAGE' | unhandledEnumCase;

export type GetConnectionError = {
  chirpErrorMessage?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
};

export type GetConnectionRequest = { connectionId: number };

export type GetHubSpotFieldRankingsError = {
  chirpErrorMessage?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
};

export type GetHubSpotFieldRankingsRequest = { connectionId: number };

export type GetHubSpotFieldRankingsResponse = {
  rankings: Default<HubSpotFieldRanking[]>;
};

export type HubSpotFieldRanking = {
  field: RankedField;
  score: number;
  scores: Default<FieldRankingScore[]>;
};

export type HubSpotFieldRankingPollStatus =
  | 'NEVER_STARTED'
  | 'PENDING'
  | 'COMPLETED'
  | 'FAILED'
  | unhandledEnumCase;

export type PollHubSpotFieldRankingsError = {
  chirpErrorMessage?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
};

export type PollHubSpotFieldRankingsRequest = { connectionId: number };

export type PollHubSpotFieldRankingsResponse = {
  status: HubSpotFieldRankingPollStatus;
  rankings: Default<HubSpotFieldRanking[]>;
};

export type PollRefreshError = {
  chirpErrorMessage?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
};

export type PollRefreshRequest = {
  connectionId: number;
  directive: RefreshUpstreamDirective;
};

export type RankedField = { name: string; label: string };

export type RefreshUpstreamDataError = {
  chirpErrorMessage?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
};

export type RefreshUpstreamDataRequest = {
  connectionId: number;
  directive: RefreshUpstreamDirective;
};

export type RefreshUpstreamDataResponse = {};

export type TriggerHubSpotFieldRankingsError = {
  chirpErrorMessage?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
};

export type TriggerHubSpotFieldRankingsRequest = { connectionId: number };

export type TriggerHubSpotFieldRankingsResponse = {};

export type UpdateConnectionError = {
  reason: ComHubspotPiesyncBridgeModelsConnectionAbstractUpdateConnectionError.FailureReason;
  chirpErrorMessage?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
};

export type UpdateConnectionRequest = {
  connectionId: number;
  settings: ConnectionSettingsMappingsUpdate;
  eventIngestionEnabled?: boolean;
};

export type UpdateConnectionResponse = {};

export type UpdateConnectionSettingsError = {
  chirpErrorMessage?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
};

export type UpdateConnectionSettingsRequest = {
  connectionId: number;
  settings: ConnectionSettingsUpdate;
};

export type UpdateConnectionSettingsResponse = {};

export namespace ComHubspotPiesyncBridgeModelsConnectionAbstractActivateConnectionError {
  export type FailureReason =
    | 'MISSING_FIELD_MAPPINGS_CUSTOMIZATION_ACCESS'
    | unhandledEnumCase;
}

export namespace ComHubspotPiesyncBridgeModelsConnectionAbstractCreateConnectionError {
  export type FailureReason =
    | 'MISSING_PERMISSIONS'
    | 'ACTIVE_CONNECTION_ALREADY_EXISTS'
    | 'ACCOUNT_NOT_FOUND'
    | 'CONNECTOR_VERIFY_FAILED'
    | unhandledEnumCase;
}

export namespace ComHubspotPiesyncBridgeModelsConnectionAbstractCreateConnectionsError {
  export type FailureReason =
    | 'MISSING_PERMISSIONS'
    | 'ACCOUNT_NOT_FOUND'
    | unhandledEnumCase;
}

export namespace ComHubspotPiesyncBridgeModelsConnectionAbstractUpdateConnectionError {
  export type FailureReason =
    | 'MISSING_FIELD_MAPPINGS_CUSTOMIZATION_ACCESS'
    | unhandledEnumCase;
}

export type ConnectionLifecycleEventListLatestAppRequest = {
  connectionIds: Default<number[]>;
  events: Default<ConnectionEvent[]>;
  appId?: number;
};

export type ConnectionLifecycleEventListResponse = {
  results: Default<ConnectionLifecycleEventResponse[]>;
  nextPageAfter?: string;
};

export type ListLatestConnectionLifecycleEventsError = {
  reason: Reason;
  chirpErrorMessage?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
};

export type Reason = 'NOT_AUTHORIZED' | unhandledEnumCase;

export type SummarizedConnectionError = {
  chirpErrorMessage?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
};

export type SummarizedConnectionRequest = {
  remoteAccountId: number;
  filterOnObjectTypeIds: Default<string[]>;
};

export type SummarizedConnectionResponse = {
  summarizedConnections: Default<SummarizedConnectionV2[]>;
};

export type SummarizedConnectionV2 = {
  id: number;
  status: ConnectionStatus;
  direction: Direction;
  datasetConfiguration: ConnectionDatasetConfiguration;
  eventSyncPreference: Default<boolean>;
};

export type GetNeedsAttentionRequest = { allowPartialResults?: boolean };

export type GetOverviewError = {
  chirpErrorMessage?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
};

export type GetPortalOverviewRequest = {};

export type NeedsAttentionItem = {
  type: NeedsAttentionItemType;
  displayName: string;
  itemId: string;
  reason: NeedsAttentionReason;
  status: NeedsAttentionItemStatus;
  lastUpdated: number;
  appName?: string;
};

export type NeedsAttentionItemStatus =
  | 'FAILED'
  | 'OFF'
  | 'ARCHIVED'
  | 'IDLE'
  | 'SYNCING'
  | 'SYNCED'
  | 'PAUSED'
  | 'UNAVAILABLE'
  | 'HAS_ERRORS'
  | unhandledEnumCase;

export type NeedsAttentionItemType =
  | 'SYNC'
  | 'EVENT_DATA_SOURCE'
  | 'IMPORT'
  | 'DATA_SOURCE'
  | unhandledEnumCase;

export type NeedsAttentionPart =
  | 'CONNECTION_HEALTH'
  | 'ACCOUNT_VERIFICATION'
  | 'IMPORTS'
  | 'DATA_SOURCES'
  | unhandledEnumCase;

export type NeedsAttentionReason =
  | 'DISCONNECTED'
  | 'LOST_AUTH'
  | 'SYNC_INVALIDATED'
  | 'IMPORT_FAILED'
  | 'IMPORT_HAS_ERRORS'
  | 'DATA_SOURCE_ERROR'
  | unhandledEnumCase;

export type NeedsAttentionResponse = {
  items: Default<NeedsAttentionItem[]>;
  incompleteParts: Default<NeedsAttentionPart[]>;
};

export type TriggerConnectionsError = {
  reason?: ComHubspotPiesyncBridgeModelsTriggerAbstractTriggerConnectionsError.FailureReason;
  chirpErrorMessage?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
};

export type TriggerConnectionsRequest = { accountId: number };

export namespace ComHubspotPiesyncBridgeModelsTriggerAbstractTriggerConnectionsError {
  export type FailureReason = 'ACCOUNT_NOT_FOUND' | unhandledEnumCase;
}

export type GetConnectionRequestType = Requestify<GetConnectionRequest>;
export type GetConnectionResponseType = ConnectionResponse;
export type GetConnectionErrorType = GetConnectionError & HubspotMetadata;
export const getConnectionRpc: ChirpAvroRpcDetails<
  GetConnectionRequestType,
  GetConnectionResponseType,
  GetConnectionErrorType,
  false
> = {
  serviceName: 'com.hubspot.piesync.bridge.rpc.ConnectionsRpc',
  rpcName: 'getConnection',
  auth: 'app',
  fingerprint: 'IyYTGKl67DKEkJIbiHiK_JMIbI95Uzou',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetSummarizedConnectionRequestType =
  Requestify<SummarizedConnectionRequest>;
export type GetSummarizedConnectionResponseType = SummarizedConnectionResponse;
export type GetSummarizedConnectionErrorType = SummarizedConnectionError &
  HubspotMetadata;
export const getSummarizedConnectionRpc: ChirpAvroRpcDetails<
  GetSummarizedConnectionRequestType,
  GetSummarizedConnectionResponseType,
  GetSummarizedConnectionErrorType,
  false
> = {
  serviceName: 'com.hubspot.piesync.bridge.rpc.ConnectionsRpc',
  rpcName: 'getSummarizedConnection',
  auth: 'app',
  fingerprint: 'fpiixki0uUO4JBasf_QMjIn9nwvlVWOw',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type TriggerConnectionsRequestType =
  Requestify<TriggerConnectionsRequest>;
export type TriggerConnectionsResponseType = TriggerBatchResponse;
export type TriggerConnectionsErrorType = TriggerConnectionsError &
  HubspotMetadata;
export const triggerConnectionsRpc: ChirpAvroRpcDetails<
  TriggerConnectionsRequestType,
  TriggerConnectionsResponseType,
  TriggerConnectionsErrorType,
  false
> = {
  serviceName: 'com.hubspot.piesync.bridge.rpc.ConnectionsRpc',
  rpcName: 'triggerConnections',
  auth: 'app',
  fingerprint: 'RxKswdXA9rWDWCfh9GEnLaJblhvdd1Xf',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type RefreshUpstreamDataRequestType =
  Requestify<RefreshUpstreamDataRequest>;
export type RefreshUpstreamDataResponseType = RefreshUpstreamDataResponse;
export type RefreshUpstreamDataErrorType = RefreshUpstreamDataError &
  HubspotMetadata;
export const refreshUpstreamDataRpc: ChirpAvroRpcDetails<
  RefreshUpstreamDataRequestType,
  RefreshUpstreamDataResponseType,
  RefreshUpstreamDataErrorType,
  false
> = {
  serviceName: 'com.hubspot.piesync.bridge.rpc.ConnectionsRpc',
  rpcName: 'refreshUpstreamData',
  auth: 'app',
  fingerprint: '1iAuv6ghx5JbdbQ0_-TZaT65uCAbgGe5',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type PollRefreshRequestType = Requestify<PollRefreshRequest>;
export type PollRefreshResponseType = UpstreamRefreshResponse;
export type PollRefreshErrorType = PollRefreshError & HubspotMetadata;
export const pollRefreshRpc: ChirpAvroRpcDetails<
  PollRefreshRequestType,
  PollRefreshResponseType,
  PollRefreshErrorType,
  false
> = {
  serviceName: 'com.hubspot.piesync.bridge.rpc.ConnectionsRpc',
  rpcName: 'pollRefresh',
  auth: 'app',
  fingerprint: 'dJkcm-fWdmq_lyOX4yBF2Lt7JLTIJGBP',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type DisableConnectionRequestType = Requestify<DisableConnectionRequest>;
export type DisableConnectionResponseType = DisableConnectionResponse;
export type DisableConnectionErrorType = DisableConnectionError &
  HubspotMetadata;
export const disableConnectionRpc: ChirpAvroRpcDetails<
  DisableConnectionRequestType,
  DisableConnectionResponseType,
  DisableConnectionErrorType,
  false
> = {
  serviceName: 'com.hubspot.piesync.bridge.rpc.ConnectionsRpc',
  rpcName: 'disableConnection',
  auth: 'app',
  fingerprint: 'qQIy7z0gAPNeWfDCAeon5kVEk6htAQTb',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type EnableConnectionRequestType = Requestify<EnableConnectionRequest>;
export type EnableConnectionResponseType = EnableConnectionResponse;
export type EnableConnectionErrorType = EnableConnectionError & HubspotMetadata;
export const enableConnectionRpc: ChirpAvroRpcDetails<
  EnableConnectionRequestType,
  EnableConnectionResponseType,
  EnableConnectionErrorType,
  false
> = {
  serviceName: 'com.hubspot.piesync.bridge.rpc.ConnectionsRpc',
  rpcName: 'enableConnection',
  auth: 'app',
  fingerprint: 'hdThjnYqpHuxjAOHmbKrp88dZSvKOHjM',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type ListLatestConnectionLifecycleEventsRequestType =
  Requestify<ConnectionLifecycleEventListLatestAppRequest>;
export type ListLatestConnectionLifecycleEventsResponseType =
  ConnectionLifecycleEventListResponse;
export type ListLatestConnectionLifecycleEventsErrorType =
  ListLatestConnectionLifecycleEventsError & HubspotMetadata;
export const listLatestConnectionLifecycleEventsRpc: ChirpAvroRpcDetails<
  ListLatestConnectionLifecycleEventsRequestType,
  ListLatestConnectionLifecycleEventsResponseType,
  ListLatestConnectionLifecycleEventsErrorType,
  false
> = {
  serviceName: 'com.hubspot.piesync.bridge.rpc.ConnectionsRpc',
  rpcName: 'listLatestConnectionLifecycleEvents',
  auth: 'app',
  fingerprint: 'o-kofkEGC0De4uRohhbdQmWasqdt2LfV',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetOverviewRequestType = Requestify<GetPortalOverviewRequest>;
export type GetOverviewResponseType = PortalOverviewResponse;
export type GetOverviewErrorType = GetOverviewError & HubspotMetadata;
export const getOverviewRpc: ChirpAvroRpcDetails<
  GetOverviewRequestType,
  GetOverviewResponseType,
  GetOverviewErrorType,
  false
> = {
  serviceName: 'com.hubspot.piesync.bridge.rpc.ConnectionsRpc',
  rpcName: 'getOverview',
  auth: 'app',
  fingerprint: 'SZXTLNb3kIwmS_g96qz7r1QzTe2G354E',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetSyncsNeedingAttentionRequestType =
  Requestify<GetNeedsAttentionRequest>;
export type GetSyncsNeedingAttentionResponseType = NeedsAttentionResponse;
export type GetSyncsNeedingAttentionErrorType = EmptyError & HubspotMetadata;
export const getSyncsNeedingAttentionRpc: ChirpAvroRpcDetails<
  GetSyncsNeedingAttentionRequestType,
  GetSyncsNeedingAttentionResponseType,
  GetSyncsNeedingAttentionErrorType,
  false
> = {
  serviceName: 'com.hubspot.piesync.bridge.rpc.ConnectionsRpc',
  rpcName: 'getSyncsNeedingAttention',
  auth: 'app',
  fingerprint: 'J7Dkon4pEOj47rciPJD48JwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type CreateConnectionRequestType = Requestify<CreateConnectionRequest>;
export type CreateConnectionResponseType = CreateConnectionResponse;
export type CreateConnectionErrorType = CreateConnectionError & HubspotMetadata;
export const createConnectionRpc: ChirpAvroRpcDetails<
  CreateConnectionRequestType,
  CreateConnectionResponseType,
  CreateConnectionErrorType,
  false
> = {
  serviceName: 'com.hubspot.piesync.bridge.rpc.ConnectionsRpc',
  rpcName: 'createConnection',
  auth: 'app',
  fingerprint: 'AhxsaHFG_XnqdbrPAePnKfNJjt0b9wzB',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type CreateConnectionsRequestType = Requestify<CreateConnectionsRequest>;
export type CreateConnectionsResponseType = CreateConnectionsResponse;
export type CreateConnectionsErrorType = CreateConnectionsError &
  HubspotMetadata;
export const createConnectionsRpc: ChirpAvroRpcDetails<
  CreateConnectionsRequestType,
  CreateConnectionsResponseType,
  CreateConnectionsErrorType,
  false
> = {
  serviceName: 'com.hubspot.piesync.bridge.rpc.ConnectionsRpc',
  rpcName: 'createConnections',
  auth: 'app',
  fingerprint: 'lZmARJLLXjD-UA3UoB4cpqU3xpgF3eLi',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type ActivateConnectionRequestType =
  Requestify<ActivateConnectionRequest>;
export type ActivateConnectionResponseType = ActivateConnectionResponse;
export type ActivateConnectionErrorType = ActivateConnectionError &
  HubspotMetadata;
export const activateConnectionRpc: ChirpAvroRpcDetails<
  ActivateConnectionRequestType,
  ActivateConnectionResponseType,
  ActivateConnectionErrorType,
  false
> = {
  serviceName: 'com.hubspot.piesync.bridge.rpc.ConnectionsRpc',
  rpcName: 'activateConnection',
  auth: 'app',
  fingerprint: '5OY8mZJJTeO6X77ruMcfpY-fREnGT8-6',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type UpdateConnectionRequestType = Requestify<UpdateConnectionRequest>;
export type UpdateConnectionResponseType = UpdateConnectionResponse;
export type UpdateConnectionErrorType = UpdateConnectionError & HubspotMetadata;
export const updateConnectionRpc: ChirpAvroRpcDetails<
  UpdateConnectionRequestType,
  UpdateConnectionResponseType,
  UpdateConnectionErrorType,
  false
> = {
  serviceName: 'com.hubspot.piesync.bridge.rpc.ConnectionsRpc',
  rpcName: 'updateConnection',
  auth: 'app',
  fingerprint: 'MSBXcXbDm3EWPYKPRGFTjtn7Mbx8ZbPg',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type UpdateConnectionSettingsRequestType =
  Requestify<UpdateConnectionSettingsRequest>;
export type UpdateConnectionSettingsResponseType =
  UpdateConnectionSettingsResponse;
export type UpdateConnectionSettingsErrorType = UpdateConnectionSettingsError &
  HubspotMetadata;
export const updateConnectionSettingsRpc: ChirpAvroRpcDetails<
  UpdateConnectionSettingsRequestType,
  UpdateConnectionSettingsResponseType,
  UpdateConnectionSettingsErrorType,
  false
> = {
  serviceName: 'com.hubspot.piesync.bridge.rpc.ConnectionsRpc',
  rpcName: 'updateConnectionSettings',
  auth: 'app',
  fingerprint: 'PQBkvf1ftJ2ClpXvQkwNo7fZQgZMHLD3',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type DeleteConnectionRequestType = Requestify<DeleteConnectionRequest>;
export type DeleteConnectionResponseType = DeleteConnectionResponse;
export type DeleteConnectionErrorType = DeleteConnectionError & HubspotMetadata;
export const deleteConnectionRpc: ChirpAvroRpcDetails<
  DeleteConnectionRequestType,
  DeleteConnectionResponseType,
  DeleteConnectionErrorType,
  false
> = {
  serviceName: 'com.hubspot.piesync.bridge.rpc.ConnectionsRpc',
  rpcName: 'deleteConnection',
  auth: 'app',
  fingerprint: 'zc70DGkB_ZK5RB9hkI9XzF2SnWGOEd3S',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetHubSpotFieldRankingsRequestType =
  Requestify<GetHubSpotFieldRankingsRequest>;
export type GetHubSpotFieldRankingsResponseType =
  GetHubSpotFieldRankingsResponse;
export type GetHubSpotFieldRankingsErrorType = GetHubSpotFieldRankingsError &
  HubspotMetadata;
export const getHubSpotFieldRankingsRpc: ChirpAvroRpcDetails<
  GetHubSpotFieldRankingsRequestType,
  GetHubSpotFieldRankingsResponseType,
  GetHubSpotFieldRankingsErrorType,
  false
> = {
  serviceName: 'com.hubspot.piesync.bridge.rpc.ConnectionsRpc',
  rpcName: 'getHubSpotFieldRankings',
  auth: 'app',
  fingerprint: 'ikd-uXO2GE9pB5OciFQUdckfu8lbg9wj',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type TriggerHubSpotFieldRankingsRequestType =
  Requestify<TriggerHubSpotFieldRankingsRequest>;
export type TriggerHubSpotFieldRankingsResponseType =
  TriggerHubSpotFieldRankingsResponse;
export type TriggerHubSpotFieldRankingsErrorType =
  TriggerHubSpotFieldRankingsError & HubspotMetadata;
export const triggerHubSpotFieldRankingsRpc: ChirpAvroRpcDetails<
  TriggerHubSpotFieldRankingsRequestType,
  TriggerHubSpotFieldRankingsResponseType,
  TriggerHubSpotFieldRankingsErrorType,
  false
> = {
  serviceName: 'com.hubspot.piesync.bridge.rpc.ConnectionsRpc',
  rpcName: 'triggerHubSpotFieldRankings',
  auth: 'app',
  fingerprint: 'KWCpAnj_rlxzZmAlOXKeX8V0ww3gmKiC',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type PollHubSpotFieldRankingsRequestType =
  Requestify<PollHubSpotFieldRankingsRequest>;
export type PollHubSpotFieldRankingsResponseType =
  PollHubSpotFieldRankingsResponse;
export type PollHubSpotFieldRankingsErrorType = PollHubSpotFieldRankingsError &
  HubspotMetadata;
export const pollHubSpotFieldRankingsRpc: ChirpAvroRpcDetails<
  PollHubSpotFieldRankingsRequestType,
  PollHubSpotFieldRankingsResponseType,
  PollHubSpotFieldRankingsErrorType,
  false
> = {
  serviceName: 'com.hubspot.piesync.bridge.rpc.ConnectionsRpc',
  rpcName: 'pollHubSpotFieldRankings',
  auth: 'app',
  fingerprint: 'CFyF0XHtDQJFF07RYJPUpgcrNcE9qAOh',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type ActivateConnectionsRequestType =
  Requestify<ActivateConnectionsRequest>;
export type ActivateConnectionsResponseType = ActivateConnectionsResponse;
export type ActivateConnectionsErrorType = EmptyError & HubspotMetadata;
export const activateConnectionsRpc: ChirpAvroRpcDetails<
  ActivateConnectionsRequestType,
  ActivateConnectionsResponseType,
  ActivateConnectionsErrorType,
  false
> = {
  serviceName: 'com.hubspot.piesync.bridge.rpc.ConnectionsRpc',
  rpcName: 'activateConnections',
  auth: 'app',
  fingerprint: 'nNK_OfVL3mZnWQyjgGKwo5wP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type EnableConnectionsRequestType = Requestify<EnableConnectionsRequest>;
export type EnableConnectionsResponseType = EnableConnectionsResponse;
export type EnableConnectionsErrorType = EmptyError & HubspotMetadata;
export const enableConnectionsRpc: ChirpAvroRpcDetails<
  EnableConnectionsRequestType,
  EnableConnectionsResponseType,
  EnableConnectionsErrorType,
  false
> = {
  serviceName: 'com.hubspot.piesync.bridge.rpc.ConnectionsRpc',
  rpcName: 'enableConnections',
  auth: 'app',
  fingerprint: 'the6qjtIsYE3LRhyYlFJz5wP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type DisableConnectionsRequestType =
  Requestify<DisableConnectionsRequest>;
export type DisableConnectionsResponseType = DisableConnectionsResponse;
export type DisableConnectionsErrorType = EmptyError & HubspotMetadata;
export const disableConnectionsRpc: ChirpAvroRpcDetails<
  DisableConnectionsRequestType,
  DisableConnectionsResponseType,
  DisableConnectionsErrorType,
  false
> = {
  serviceName: 'com.hubspot.piesync.bridge.rpc.ConnectionsRpc',
  rpcName: 'disableConnections',
  auth: 'app',
  fingerprint: 'cqcAqfwIoLLPRfW7lbab8JwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};
